import { UIComponent } from "@aptus/frontend-core";
import { AutoCompleteSelect } from "components/form/autoCompleteSelect/autoCompleteSelect";
import { GrapeSelectProps, useGrapeSelect } from "./useGrapeSelect";

export const GrapeSelect: UIComponent<GrapeSelectProps> = (props) => (
	<AutoCompleteSelect {...useGrapeSelect(props)} />
);
